import React from "react";
import { withRouter, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { authenticatedSelector, securityIsFetchingSelector, hasRequiredRoleSelector} from "../security/securitySelectors";
import { ImportLoading } from "../common";

const PrivilegedRouteComponent = ({
  authenticated,
  isLoading,
  hasRequiredRole,
  component: Component,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (isLoading && !authenticated) {
          return <ImportLoading isLoading={true}/>
        } else if (!isLoading && authenticated && hasRequiredRole) {
          return <Component {...props} />
        } else {
          return <Redirect to={'/app/forbidden'}/>
        }
      }}
    />
  )
}

const mapStateToProps = (state, ownProps) => ({
  authenticated: authenticatedSelector(state),
  isLoading: securityIsFetchingSelector(state),
  hasRequiredRole: hasRequiredRoleSelector(state,ownProps)
});

const PrivilegedRoute = withRouter(connect(mapStateToProps)(PrivilegedRouteComponent));
export { PrivilegedRoute };



// WEBPACK FOOTER //
// ./src/common/PrivilegedRoute.js